export const getOracleByteLength = (str) => {
    if (!str)
        return 0;
    const encoder = new TextEncoder();
    return encoder.encode(str).length;
};
